import { commonDescendingComparator } from 'utils/helper';

export const COLUMNS = [
    {
        id: 'filename',
        columnTitle: 'File Name',
        comparator: (order, submissions, _) => {
            if (!order) return submissions;
            const getter = (submission) => {
                return submission.data.original_file ? submission.data.original_file.name : submission.data.name;
            };

            if (order === 'desc') {
                const sortedSubmissions = [...submissions].sort((a, b) => commonDescendingComparator(a, b, getter));
                return sortedSubmissions;
            }
            const sortedSubmissions = [...submissions].sort((a, b) => -commonDescendingComparator(a, b, getter));
            return sortedSubmissions;
        },
    },
    {
        id: 'status',
        columnTitle: 'Status',
        comparator: (order, submissions, _) => {
            if (!order) return submissions;
            const getter = (submission) => {
                if (submission.grading) {
                    return 'Reviewed';
                }
                if (submission.ai) {
                    return 'Ready for review';
                }
                if (submission.is_failed) {
                    return 'Failed to process';
                }
                return null;
            };

            if (order === 'desc') {
                const sortedSubmissions = [...submissions].sort((a, b) => commonDescendingComparator(a, b, getter));
                return sortedSubmissions;
            }
            const sortedSubmissions = [...submissions].sort((a, b) => -commonDescendingComparator(a, b, getter));
            return sortedSubmissions;
        },
    },
    {
        id: 'grade',
        columnTitle: 'Final Grade',
        comparator: (order, submissions, assignment) => {
            if (!order) return submissions;
            const getter = (submission) => {
                if (!submission.grading || !assignment.ai_grading_enabled) return '--';
                const score = Object.entries(submission.grading.criteria).reduce((acc, [criterionId, optionId]) => {
                    const { rate } = assignment.rubric.criteria
                        .find(({ id }) => id === criterionId)
                        .options.find(({ id }) => id === optionId);
                    return acc + Number(rate);
                }, 0);
                const maxScore = assignment.rubric.criteria.reduce((acc, criterion) => {
                    return acc + Math.max(...criterion.options.map(({ rate }) => Number(rate)));
                }, 0);
                return `${score}/${maxScore}`;
            };

            if (order === 'desc') {
                const sortedSubmissions = [...submissions].sort((a, b) => commonDescendingComparator(a, b, getter));
                return sortedSubmissions;
            }
            const sortedSubmissions = [...submissions].sort((a, b) => -commonDescendingComparator(a, b, getter));
            return sortedSubmissions;
        },
    },
];
